var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.833 17.6667C16.833 19.9663 18.7 21.8333 20.9997 21.8333C23.2993 21.8333 25.1663 19.9663 25.1663 17.6667C25.1663 15.367 23.2993 13.5 20.9997 13.5C18.7 13.5 16.833 15.367 16.833 17.6667V17.6667",
    stroke: "#4B1498",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6663 28.4987C27.6663 24.8193 24.6791 21.832 20.9997 21.832C17.3202 21.832 14.333 24.8193 14.333 28.4987",
    stroke: "#4B1498",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon);
export default __webpack_public_path__ + "static/media/gender-icon.83d9e08661834886e15ef827e22634e4.svg";
export { ForwardRef as ReactComponent };